import React, { useState, useEffect } from 'react';
import { settingsAPI } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { Bell } from 'lucide-react';
import { toast } from 'sonner';

export function NotificationSettings() {
  var [billing, setBilling] = useState(true);
  var [reopen, setReopen] = useState(true);
  var [loaded, setLoaded] = useState(false);

  useEffect(function() {
    settingsAPI.getNotifications().then(function(res) {
      setBilling(res.data.notify_employee_on_billing);
      setReopen(res.data.notify_employee_on_reopen);
      setLoaded(true);
    }).catch(function() { setLoaded(true); });
  }, []);

  function save(newBilling, newReopen) {
    settingsAPI.updateNotifications({
      notify_employee_on_billing: newBilling,
      notify_employee_on_reopen: newReopen,
    }).then(function() {
      toast.success('Benachrichtigungseinstellungen gespeichert');
    }).catch(function() {
      toast.error('Fehler beim Speichern');
    });
  }

  function toggleBilling(val) {
    setBilling(val);
    save(val, reopen);
  }

  function toggleReopen(val) {
    setReopen(val);
    save(billing, val);
  }

  if (!loaded) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Bell className="h-5 w-5" />
          E-Mail-Benachrichtigungen
        </CardTitle>
        <CardDescription>Automatische Status-E-Mails an Mitarbeiter</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between" data-testid="notify-billing-switch">
          <div>
            <Label className="text-sm font-medium">Bei Abrechnung</Label>
            <p className="text-xs text-slate-500">Mitarbeiter wird benachrichtigt, wenn sein Stundenzettel abgerechnet wurde</p>
          </div>
          <Switch checked={billing} onCheckedChange={toggleBilling} />
        </div>
        <div className="flex items-center justify-between" data-testid="notify-reopen-switch">
          <div>
            <Label className="text-sm font-medium">Bei Rückgabe</Label>
            <p className="text-xs text-slate-500">Mitarbeiter wird benachrichtigt, wenn sein Stundenzettel zur Korrektur zurückgegeben wird</p>
          </div>
          <Switch checked={reopen} onCheckedChange={toggleReopen} />
        </div>
      </CardContent>
    </Card>
  );
}
